<template>
  <div class="result-card">
    <Cover
      ref="cover"
      :opponent="opponent"
      @open="animation.play()"
      :unlocked="unlocked"
      :flipped="flipped"
      :round="round"
    />
    <Carousel
      v-if="round"
      ref="carousel"
      :opponent="opponent"
      @close="animation.reverse()"
      :round="round"
    />
  </div>
</template>

<script>
import Cover from './partials/Cover/Cover'
import Carousel from './partials/Carousel/Carousel'
import { TimelineMax, Power4, TweenMax } from 'gsap'
export default {
  components: {
    Cover,
    Carousel
  },
  props: {
    opponent: {
      type: Object,
      required: true
    },
    flipped: {
      type: Boolean,
      required: true
    },
    round: {
      validator: prop => typeof prop === 'object' || prop === null,
      required: true
    },
    unlocked: {
      type: Boolean,
      required: true
    }
  },
  mounted () {
    if (this.round) this.initAnimation()
    else this.$el.style.height = this.coverHeight
  },
  data () {
    return {
      console: console,
      animation: null,
      coverHeight: '11rem',
      carouselHeight: '32.5rem',
      carouselOpen: false,
      duration: 0.5,
      ease: Power4.easeInOut
    }
  },
  methods: {
    initAnimation () {
      const carousel = this.$refs['carousel'].$el
      const cover = this.$refs['cover'].$el
      TweenMax.set(carousel, { pointerEvents: 'none' })
      this.animation = new TimelineMax({ paused: true, onComplete: updatePointerEvents, onReverseComplete: updatePointerEvents })
      this.animation.fromTo(this.$el, this.duration, { height: this.coverHeight }, { height: this.carouselHeight, ease: this.ease }, 0)
      this.animation.to(cover, this.duration, { autoAlpha: 0, ease: this.ease }, 0)
      this.animation.from(carousel, this.duration, { autoAlpha: 0, ease: this.ease }, 0)
      function updatePointerEvents () {
        this.carouselOpen = !this.carouselOpen
        TweenMax.set(this.carouselOpen ? cover : carousel, { pointerEvents: 'none' })
        TweenMax.set(this.carouselOpen ? carousel : cover, { pointerEvents: 'all' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.result-card {
  width: 100%;
  display: flex;
  position: relative;
}
.cover,
.carousel {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
